import { render } from "./addModuleShop.vue?vue&type=template&id=6efe9de6"
import script from "./addModuleShop.vue?vue&type=script&lang=js"
export * from "./addModuleShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__